export default __webpack_public_path__ + "static/media/folder.0c16ef30.png";